/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 */

import config from "@/config";
import axios from "axios";
import store from "@/store";

export default {
	getUserObjects(featureReference = config.SOUND_PLUS_LIVE_CONSOLE_ACCESS_FEATURE_REF) {
		return axios.get(`${config.SERVICE_MANAGEMENT_URL}/api/v1/subjects/me/features/${featureReference}/objects`, {
			headers: {
				"Authorization": store.getters.getAccessToken()
			}
		});
	},

	getUserFeatures({service_id, object_id}) {
		return axios.get(`${config.SERVICE_MANAGEMENT_URL}/api/v1/subjects/me/services/${service_id}/objects/${object_id}/permissions`,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	getServiceFeatures({service_id}) {
		return axios.get(`${config.SERVICE_MANAGEMENT_URL}/api/v1/services/${service_id}/features`,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	getUserByID(userID) {
		return axios.get(`${config.SERVICE_MANAGEMENT_URL}/api/v1/subjects/${userID}`, {
			headers: {
				"Authorization": store.getters.getAccessToken()
			}
		});
	}
}
